// @mui
import { Stack, Box } from '@mui/material';
// config
import { NAV } from 'consts/ui';
// utils
import { hideScrollbarX } from 'util/cssStyles';
// components
import Logo from 'lib/logo';
import { NavSectionMini } from 'lib/nav-section';
//
import useConfig from './useNavConfig';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { getConfig } = useConfig();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini data={getConfig()} />
      </Stack>
    </Box>
  );
}
